/**
 * «hace 5 minutos», «ayer», «hace 3 días» in the UI locale. Browsers below
 * `Intl.RelativeTimeFormat` (Chrome 71 / Safari 14, under the admin floor)
 * get the short date instead («12 sept»).
 */
export function relativeTimeLabel(
  fromIso: string,
  now: Date,
  locale: string
): string {
  const from = new Date(fromIso);
  const fromMs = from.getTime();
  if (!Number.isFinite(fromMs)) return '';
  const minutes = Math.max(0, Math.floor((now.getTime() - fromMs) / 60_000));
  if (typeof Intl.RelativeTimeFormat === 'function') {
    try {
      const format = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
      if (minutes < 60) return format.format(-Math.max(1, minutes), 'minute');
      if (minutes < 1440)
        return format.format(-Math.floor(minutes / 60), 'hour');
      return format.format(-Math.floor(minutes / 1440), 'day');
    } catch {
      // Unsupported locale: fall through to the date.
    }
  }
  try {
    return from.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
  } catch {
    return from.toLocaleDateString();
  }
}
